import { alpha } from "@mui/material"
import { blueGrey, lightBlue } from "../../../../../mp-core/themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ palette, breakpoints, spacing }) => ({
  mainLinksDropDown: {
    display: "flex",
    marginRight: spacing(2),
    marginLeft: spacing(2),
    zIndex: 1,
    position: "relative",
    [breakpoints.down("sm")]: {
      display: "block"
    }
  },
  paper: {
    marginRight: spacing(2),
    zIndex: 2,
    borderTopLeftRadius: 0,
    [breakpoints.down("sm")]: {
      margin: 0
    }
  },
  mainButton: {
    backgroundColor: palette.primary[500],
    "&:hover": {
      backgroundColor: palette.primary[600]
    },
    "&[aria-controls=menu-list-grow]": {
      backgroundColor: "white",
      color: palette.primary.main
    },
    "&:focus": {
      outline: "none"
    },
    [breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "space-between"
    },
    [breakpoints.up("md")]: {
      backgroundColor: palette.primary.main
    }
  },
  mainButtonIcon: {
    fontSize: "0.6875rem"
  },
  menuList: {
    color: palette.primary[500],
    fontSize: "0.6875rem",
    width: 195,
    [breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  menuListItem: {
    paddingBottom: spacing(1),
    paddingTop: spacing(1)
  },
  menuItemSelected: {
    backgroundColor: `${palette.secondary[50]} !important`
  },
  menuListItemIcon: {
    minWidth: 32,
    fontSize: "0.88rem",
    color: palette.primary[500]
  },
  menuListItemText: {
    "& span": {
      fontSize: "0.88rem"
    }
  },
  menuListItemSubheader: {
    fontSize: "0.5875rem",
    textTransform: "uppercase",
    lineHeight: "32px"
  },
  logo: {
    [breakpoints.down("md")]: {
      margin: "0 auto",
      textAlign: "center"
    }
  },
  navbar: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    [breakpoints.down("md")]: {
      flex: 0
    }
  },
  sideBar: {
    minWidth: "238px",
    position: "absolute",
    padding: spacing(3),
    backgroundColor: palette.primary[900],
    maxHeight: "calc(100vh - 60px)",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "4px"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ffffff5c"
    }
  },
  dropdowns: {
    [breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "center",
      margin: spacing(1, 0),
      "& > div": {
        margin: spacing(1, 0)
      }
    }
  },
  dropdownPopper: {
    transform: "none !important",
    [breakpoints.down("sm")]: {
      position: "relative!important" as "relative"
      // willChange: "unset !important"
    }
  },
  searchRoot: {
    borderRadius: 100,
    backgroundColor: palette.primary[800],
    padding: spacing(1, 3),
    color: "#fff",
    width: "100%",
    "&::placeholder": {
      color: "#B0BEC5"
    },
    "&:after": {
      display: "none"
    }
  },
  questionIconButton: {
    marginLeft: spacing(4),
    backgroundColor: blueGrey[900],
    border: `1px solid ${blueGrey[900]}`,
    outline: "none",

    ":hover": {
      textDecoration: "none"
    },

    "&:focus": {
      border: `1px solid ${lightBlue[300]}`,
      outline: `3px solid ${alpha(lightBlue[200], 0.2)}`
    },

    "& > .material-icons": {
      color: "#fff"
    }
  }
}))
